<template>
	<header :class="{ 'bg-transparent': parceiro }" class="container land-page-header">
		<template>
			<img v-if="parceiro && parceiroConfig.logo != null" :src="parceiroConfig.logo" />
			<img @click="$router.push({ name: 'LandPageParceiro' })" v-else src="../../../assets/images/logo.png" />
		</template>

		<menu v-if="parceiroConfig != null">
			<ul>
				<li v-if="parceiro && parceiroConfig.sessoes.about && parceiroConfig.sessoes.about.campos" @click="goToSection('about')" :style="corPrimaria">Sobre</li>
				<li v-if="parceiro && parceiroConfig.sessoes.tutorial && parceiroConfig.sessoes.tutorial.campos" @click="goToSection('tutorial')" :style="corPrimaria">Como funciona</li>
				<li v-if="parceiro && parceiroConfig.sessoes.contact && parceiroConfig.sessoes.contact.campos" @click="goToSection('contact')" :style="corPrimaria">Contato</li>
				<li
					v-if="parceiro && parceiroConfig.sessoes.creditor != null"
					@click="
						$router.push({
							name: 'RegisterCreditor'
						})
					"
					:style="corPrimaria"
				>
					Seja um credor parceiro
				</li>
				<li v-if="parceiroConfig.sessoes.customization == undefined ? true : parceiroConfig.sessoes.customization.campos.landPage.flgAcessoCredor" @click="openAdmin()" :style="corPrimaria">Acesso credor</li>
			</ul>
			<div class="land-page-menu-mobile" :style="corPrimaria">
				<i class="fas fa-bars" @click="showMobile = true" />
				<div class="menu-background-full" v-if="showMobile">
					<i class="fas fa-times" @click="showMobile = false" />
					<img v-if="parceiro" @click="$router.push({ name: 'LandPageParceiro' })" :src="parceiroConfig.sessoes.logoForBackgroundWhite.campos" alt="logo" />
					<img v-else @click="$router.push({ name: 'LandPageParceiro' })" src="../../../assets/images/logo.png" alt="logo" />
					<ul style="display: flex; flex-direction: column">
						<li v-if="parceiro && parceiroConfig.sessoes.about && parceiroConfig.sessoes.about.campos" @click="goToSection('about')" :style="corPrimaria" v-show="!nokia">Sobre</li>
						<li v-if="parceiro && parceiroConfig.sessoes.tutorial && parceiroConfig.sessoes.tutorial.campos" @click="goToSection('tutorial')" :style="corPrimaria" v-show="!nokia">Como funciona</li>
						<li v-if="parceiro && parceiroConfig.sessoes.contact && parceiroConfig.sessoes.contact.campos" @click="goToSection('contact')" :style="corPrimaria" v-show="!nokia">Contato</li>
						<li
							v-if="parceiro && parceiroConfig.sessoes.creditor != null"
							@click="
								$router.push({
									name: 'RegisterCreditor'
								})
							"
							:style="corPrimaria"
						>
							Seja um credor parceiro
						</li>
						<li v-if="parceiroConfig.sessoes.customization == undefined ? true : parceiroConfig.sessoes.customization.campos.landPage.flgAcessoCredor" @click="openAdmin()" :style="corPrimaria">Acesso credor</li>
					</ul>
				</div>
			</div>
		</menu>
	</header>
</template>

<script>
import Header from "../../../components/Header"
import { mapState } from "vuex"
import Template from "../../admin/Template"
import ButtonDefault from "../../../components/buttons/ButtonDefault"
export default {
	name: "LandPageHeader",
	components: { ButtonDefault, Template, Header },
	props: ["backgroundTransparent"],
	data() {
		return {
			showMobile: false,
			nokia: window.innerWidth == 240
		}
	},
	methods: {
		openAdmin() {
			window.open("https://app.acerteaqui.com/", "_blank")
		},
		goToSection(section) {
			if (this.$route.name !== "LandPageParceiro") {
				this.$router.push({ name: "LandPageParceiro" })
			} else {
				var element = this.$parent.$parent.$refs[section]
				var top = element.offsetTop
				element.scrollIntoView({ behavior: "smooth", top })
				this.showMobile = false
			}
		},
		onResize() {
			this.nokia = window.innerWidth == 240
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener("resize", this.onResize)
		})
	},

	beforeDestroy() {
		window.removeEventListener("resize", this.onResize)
	},
	computed: {
		...mapState({
			parceiro: state => state.parceiro,
			parceiroConfig: state => state.parceiroConfig,
			corPrimaria: state => state.corPrimaria,
			corSecundaria: state => state.corSecundaria
		})
	}
}
</script>

<style scoped lang="scss">
.land-page-header {
	background: transparent !important;
	display: flex;
	justify-content: space-between;
	img {
		margin-top: 20px;
		width: 264px;
		height: 156px;
		box-sizing: border-box;
		cursor: pointer;
		@media only screen and (max-width: 1245px) {
			width: 30%;
			height: 80%;
		}
		@media only screen and (max-width: 768px) {
			width: 40%;
			height: 90%;
		}
		@media only screen and (max-width: 240px) {
			width: 20%;
		}
	}
	menu {
		ul {
			display: flex;
			gap: 20px;
			justify-content: flex-end;
			margin-top: 50px;
			li {
				display: inline-block;
				font-size: 18px;
				background-color: var(--color);
				color: var(--whiteColor);
				font-family: "Roboto-Bold", sans-serif;
				cursor: pointer;
				padding: 15px;
				width: fit-content;
				height: fit-content;
				border-radius: 27px;
				transition: all 0.2s ease-in-out;
				border: 2px solid var(--whiteColor);
				&:hover {
					background-color: var(--hovercolor);
					color: var(--whiteColor);
					transition: all 0.2s ease-in-out;
					border: 2px solid var(--whiteColor);
				}
				@media only screen and (max-width: 1245px) {
					width: 110%;
					margin-bottom: 15px;
					display: flex;
					justify-content: center;
					padding: 12px;
					font-size: 18px;
					font-family: "Roboto-Bold", sans-serif;
					color: var(--whiteColor);
					cursor: pointer;
					a {
						font-size: 32px;
						color: var(--whiteColor);
						font-family: Cabin;
						text-align: center;
					}
				}
				@media only screen and (max-width: 768px) {
					width: 100%;
					margin-bottom: 10px;
				}
				@media only screen and (max-width: 414px) {
					margin-bottom: 10px;
				}
				@media only screen and (max-width: 240px) {
					width: 90%;
					font-size: 15px;
					margin: 0px;
				}
			}
			@media only screen and (max-width: 1245px) {
				display: none;
			}
			@media only screen and (max-width: 240px) {
				justify-content: center;
				gap: 20;
				margin: 0px;
			}
		}
	}
}
.land-page-menu-mobile {
	display: none;
	align-content: center;
	justify-content: end;

	@media only screen and (max-width: 1245px) {
		display: flex;
	}
	i {
		font-size: 32px;
		color: var(--whiteColor);
		cursor: pointer;
	}
}

.menu-background-full {
	position: fixed;
	width: 100%;
	height: 100vh;
	left: 0;
	top: 0;
	background: var(--whiteColor);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 900;
	@media only screen and (max-width: 240px) {
		justify-content: flex-start;
		height: 200vh;
	}

	img {
		width: 50%;
		height: 25%;
		margin-bottom: 35px;
		@media only screen and (max-width: 450px) {
			height: 20vh;
			margin-bottom: 20px;
		}
		@media only screen and (max-width: 240px) {
			width: 50%;
			margin-right: 15px;
		}
	}

	i {
		font-size: 38px;
		color: var(--color);
		position: absolute;
		right: 5vw;
		top: 2vh;
		@media only screen and (max-width: 240px) {
			right: 15vw;
			font-size: 20px;
		}
	}
}
</style>
